/*
 For interacting with the TrainHeroic API
 */

// Copyright (c) 2017 TrainHeroic LLC
//
// Authentcation API library.
import { authenticatedFetch, authenticatedFileUpload } from './request';

export async function del(url, onFail) {
    return await authenticatedFetch(url, { method: 'DELETE' }, onFail);
}

export async function fileUpload(url, file) {
    return await authenticatedFileUpload(url, file);
}

export async function get(url, onFail) {
    return await authenticatedFetch(url, { method: 'GET' }, onFail);
}

export async function post(url, body, onFail) {
    return await authenticatedFetch(
        url,
        { method: 'POST', body: JSON.stringify(body) },
        onFail
    );
}

export async function put(url, body, onFail) {
    return await authenticatedFetch(
        url,
        { method: 'PUT', body: JSON.stringify(body) },
        onFail
    );
}



// WEBPACK FOOTER //
// ./src/api/api.js